import { registerLocaleData } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocaleService {
  private locale: string;

  constructor() {
    this.locale = navigator.language;
    this.initializeLocale(this.locale);
  }

  getLocale(): string {
    return this.locale;
  }

  private async initializeLocale(locale: string): Promise<void> {
    try {
      await this.importLocale(locale);
    } catch {
      await this.importLocale(locale.split('-')[0]);
    }
  }

  private async importLocale(locale: string): Promise<void> {
    const fallbackLocaleModule = await import(
      /* @vite-ignore */
      `/assets/locales/${locale}.mjs`
    );

    registerLocaleData(fallbackLocaleModule.default, locale);

    this.locale = locale;
  }
}
